import * as XLSX from "xlsx";
import { ExporterType } from "../types/Export";
import { formatDate } from "../utils/Validation";
import excel from "../assets/excel.png";
import { 
    RedemptionHistoryKeys, 
    ApproveRejectRedemptionKeys, 
    KycReportKeys, 
    TicketsReportKeys, 
    ScanHistoryKeys 
} from "../utils/ExportKeyMappings";
import "./Layout.css";

const ExporterButton = ({
    exporter,
    reportName,
}: ExporterType) => {
    const downloadExcel = async () => {
        try {
            const data = await exporter();
            if (!data?.length) {
                return;
            }

            let mappings: any;

            switch (reportName) {
                case "Redemption History":
                    mappings = RedemptionHistoryKeys;
                    break;
                case "Approve / Reject Redemption":
                    mappings = ApproveRejectRedemptionKeys;
                    break;
                case "KYC Report":
                    mappings = KycReportKeys;
                    break;
                case "Tickets Report":
                    mappings = TicketsReportKeys;
                    break;
                case "Scan History":
                    mappings = ScanHistoryKeys;
                    break;
                default:
                    return;
            }

            const worksheet = XLSX.utils.json_to_sheet(
                data?.map((ele: any) => {
                    return Object.keys(mappings).reduce((acc: any, key: any) => {
                        if ([
                            "createdAt",
                        ].includes(key)) {
                            acc[mappings[key]] = ele[key]
                                ? formatDate(ele[key], "dd MMM yyyy")
                                : "";
                        }
                        else if (
                            [

                                "points",

                            ].includes(key)
                        ) {
                            acc[mappings[key]] = ele[key] || "0";
                        } else {
                            acc[mappings[key]] = ele[key] || "";
                        }
                        return acc;
                    }, {});
                })
            );
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, `${reportName}.xlsx`);
        } catch (e) { }
    };
    return (
        <button className="export-button" onClick={(e) => downloadExcel()}>
            <img src={excel} className="export-button-img" />
            Export
        </button>
    );
};

export default ExporterButton;